<template>
  <header class="nav-header" :class="navClass">
    <div class="nav-wrap">
      <div class="logo hand" @click="$router.push('/')">
        <img src="http://ylxh-service.oss-cn-hangzhou.aliyuncs.com/logo.png" alt="" class="logo-img" />
      </div>
      <div class="menu-content" v-show="!searchStatus">
        <div class="menu-item"
             :class="item.uri === activeMenuUri ? 'active' : ''"
             v-for="(item, index) in menus"
             :key="index"
             @click="navTo(item.uri)">{{item.name}}</div>
      </div>
      <div class="search-content" @click.stop="" v-if="searchStatus">
        <div class="close hand" @click="hideSearch"><img src="../assets/images/delete.svg" alt=""></div>
        <input type="text" autofocus placeholder="搜索" v-model="searchText" />
        <div class="search-box hand"><img src="../assets/images/search.svg" alt=""></div>
      </div>
      <div class="opt-content" v-if="!user">
        <div class="search-box hand" v-show="!searchStatus" @click.stop="onSearchClick"><img src="../assets/images/search.svg" alt=""></div>
        <div class="login-btn hand" @click="navTo('/login')">登录</div>
        <div class="split-line"></div>
        <div class="register-dropdown">
          <div class="register-btn hand">注册</div>
          <div class="register-menu-box">
            <div class="trans-bg"></div>
            <div class="register-menu-wrap">
              <div class="register-menu-title">选择注册类型</div>
              <div class="register-menu-item hand" @click="navTo('/member/group/register')">
                <span class="register-menu-icon is-group"></span>
                <span class="register-menu-text">
                  <span class="register-menu-name">注册团体会员</span>
                  <span class="register-menu-desc">单位 / 企业入会</span>
                </span>
              </div>
              <div class="register-menu-item hand" @click="navTo('/member/person/register')">
                <span class="register-menu-icon is-person"></span>
                <span class="register-menu-text">
                  <span class="register-menu-name">注册个人会员</span>
                  <span class="register-menu-desc">个人申请入会</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="opt-content" v-else>
        <div class="notify hand" @click="navTo('/system/user?c=Notify')">
          <img src="../assets/images/icon-notify.png" alt="">
          <span v-if="unReadCount">{{unReadCount}}</span>
        </div>
        <div class="user-box">
          <div class="user-icon"><img :src="user.portraitUrl" alt=""></div>
          <div class="user-name" :title="user.userName">{{user.userName}}</div>
          <div class="user-menu-box">
            <div class="trans-bg"></div>
            <div class="user-menu-wrap">
              <div class="user-menu-item"
                  :class="menuItem.class"
                  v-for="(menuItem, index) in userMenu"
                  :key="index"
                  @click="menuClick(menuItem)">
                <img :src="menuItem.icon" alt="">
                <span>{{menuItem.name}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>


<script>
import router from '@/router';
import { mapState, mapActions } from 'vuex';
import userIcon from '../assets/images/icon-user.png';
import settingIcon from '../assets/images/icon-setting.png';
import logoutIcon from '../assets/images/icon-logout.png';

export default {
  data() {
    return {
      searchStatus: false,
      searchText: '',
      userMenu: [{
        icon: userIcon,
        name: '个人中心',
        id: 'user'
      }, {
        icon: settingIcon,
        name: '账号设置',
        id: 'accout',
        class: 'border-b'
      }, {
        icon: logoutIcon,
        name: '退出登录',
        id: 'logout'
      }]
    }
  },
  computed: {
    ...mapState(['menus', 'activeMenuUri', 'user', 'unReadCount']),
    navClass() {
      return this.activeMenuUri === '/' ? '' : 'normal-nav-header';
    }
  },
  mounted() {
    this._hideSearch = this.hideSearch.bind(this);
    this.getUnReadCount();
  },
  methods: {
    ...mapActions(['onLogout', 'getUnReadCount']),
    onSearchClick() {
      this.searchStatus = true;
      document.body.addEventListener('click', this._hideSearch);
    },
    hideSearch() {
      this.searchStatus = false;
      this.searchText = '';
    },
    navTo(uri) {
      router.push(uri);
    },
    menuClick(item) {
      const { id } = item; 
      if (id === 'user') {
        this.navTo('/system/user');
      } else if (id === 'accout') {
        this.navTo('/system/user?c=BaseInfo');
      } else if (id === 'logout') {
        this.onLogout().then(() => {
          localStorage.removeItem('token');
          router.replace('/login');
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@middleWidth: 1300px;
.nav-header {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  width: 100%;
  height: 80px;
  background: rgba(253, 255, 253, 0.5);
  backdrop-filter: blur(5px);

  &.normal-nav-header {
    position: relative;
  }

  .nav-wrap {
    width: @middleWidth;
    margin: 0 auto;
    display: flex;
    height: 100%;
    align-items: center;

    .logo {
      margin-right: 30px;
      height: 52px;

      > img {
        width: 308px;
        height: 100%;
      }
    }

    .menu-content {
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;

      > .menu-item {
        height: 22px;
        font-size: 16px;
        color: #131415;
        line-height: 22px;
        position: relative;
        margin-right: 30px;
        cursor: pointer;

        &:hover,
        &.active {
          font-weight: 600;

          &::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: -7px;
            width: 100%;
            height: 4px;
            background: #06ae63;
          }
        }
      }
    }

    .search-content {
      flex: 1;
      height: 100%;
      padding-left: 20px;
      padding-right: 100px;
      display: flex;
      align-items: center;

      .close {
        width: 15px;
        height: 15px;
      }

      > input {
        background: transparent;
        flex: 1;
        height: 100%;
        appearance: none;
        font-size: 14px;
        border: 0px;
        outline: 0px;
        color: rgb(68, 68, 68);
        padding-left: 10px;
        padding-right: 30px;
      }
    }
    
    .search-box {
      width: 25px;
      height: 25px;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .opt-content {
      height: 100%;
      display: flex;
      align-items: center;
      position: relative;

      .login-btn {
        padding: 0 10px;
      }

      .split-line {
        width: 1px;
        height: 10px;
        background: #444;
      }

      .register-btn {
        padding: 0 10px;
        transition: color 0.2s ease;
      }

      .register-dropdown {
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;

        &:hover {
          .register-btn {
            color: #06ae63;
          }

          .register-menu-box {
            visibility: visible;
            opacity: 1;
            pointer-events: auto;
            transform: translateY(0);
          }
        }
      }

      .register-menu-box {
        visibility: hidden;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        right: -8px;
        top: calc(100% - 4px);
        padding-top: 12px;
        z-index: 20;
        transform: translateY(6px);
        transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s ease;

        .trans-bg {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 16px;
        }

        .register-menu-wrap {
          width: 220px;
          padding: 14px 12px;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 12px 32px rgba(19, 20, 21, 0.12);
          border: 1px solid rgba(6, 174, 99, 0.12);
          position: relative;

          &::before {
            content: '';
            position: absolute;
            top: -6px;
            right: 28px;
            width: 12px;
            height: 12px;
            background: #fff;
            border-left: 1px solid rgba(6, 174, 99, 0.12);
            border-top: 1px solid rgba(6, 174, 99, 0.12);
            transform: rotate(45deg);
          }
        }

        .register-menu-title {
          padding: 0 8px 10px;
          font-size: 12px;
          color: #8c8c8c;
          letter-spacing: 0.5px;
          font-family: PingFangSC-Regular, PingFang SC;
        }

        .register-menu-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 10px;
          border-radius: 8px;
          transition: background 0.2s ease, transform 0.2s ease;

          & + .register-menu-item {
            margin-top: 4px;
          }

          &:hover {
            background: rgba(6, 174, 99, 0.08);

            .register-menu-name {
              color: #06ae63;
            }

            .register-menu-icon {
              background: #06ae63;
              color: #fff;
            }
          }
        }

        .register-menu-icon {
          width: 36px;
          height: 36px;
          flex-shrink: 0;
          border-radius: 10px;
          background: #eefaf3;
          color: #06ae63;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background 0.2s ease, color 0.2s ease;
          position: relative;

          &::before {
            font-size: 14px;
            font-weight: 600;
            font-family: PingFangSC-Medium, PingFang SC;
            line-height: 1;
          }

          &.is-group::before {
            content: '团';
          }

          &.is-person::before {
            content: '个';
          }
        }

        .register-menu-text {
          display: flex;
          flex-direction: column;
          gap: 2px;
          min-width: 0;
        }

        .register-menu-name {
          font-size: 14px;
          font-weight: 500;
          color: #131415;
          font-family: PingFangSC-Medium, PingFang SC;
          line-height: 1.3;
          transition: color 0.2s ease;
        }

        .register-menu-desc {
          font-size: 12px;
          color: #999;
          font-family: PingFangSC-Regular, PingFang SC;
          line-height: 1.3;
        }
      }

      .notify {
        width: 18px;
        height: 20px;
        margin-right: 20px;
        position: relative;

        img {
          width: 100%;
          height: 100%;
          display: block;
        }

        > span {
          width: 20px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          color: #fff;
          position: absolute;
          right: -10px;
          top: -10px;
          background: #FF3B2F;
          border-radius: 50%;
          font-size: 12px;
        }
      }

      .user-box {
        height: 100%;
        display: flex;
        align-items: center;
        cursor: pointer;

        &:hover {
          .user-menu-box {
            display: block;
          }
        }

        .user-icon {
          width: 32px;
          height: 32px;
          margin-right: 8px;

          > img {
            width: 100%;
            height: 100%;
            display: block;
            border-radius: 50%;
          }
        }

        .user-name {
          max-width: 60px;
          overflow: hidden;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #131415;
        }
      }

      .user-menu-box {
        display: none;
        width: 126px;
        position: absolute;
        right: 0;
        top: 100%;

        .trans-bg {
          width: 100%;
          height: 4px;
          background: transparent;
        }

        .user-menu-wrap {
          background: #FFFFFF;
          box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.04);
          padding: 24px;
        }

        .user-menu-item {
          display: flex;
          align-items: center;
          margin-bottom: 24px;
          justify-content: space-between;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #131415;
          cursor: pointer;

          &:last-child {
            margin-bottom: 0;
          }

          &.border-b {
            padding-bottom: 23px;
            border-bottom: 1px solid #EEEEEE;
            margin-bottom: 20px;
          }

          &:hover {
            color: #06ae63;
          }

          img {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
  }
}
</style>